<template>
  <mrc_ess_skeleton_loader :loading="skLoading">
    <div>
      <mrc_ess_iconGroup
        style="top: -50px"
        :is_disabled="disabled"
        :show_del="false"
        :showReturn="false"
        @handleReturn="handleReturn"
        @handleEdit="handleEdit"
        @handleDel="handleDel"
      ></mrc_ess_iconGroup>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_server_host',
                    maxLength(20).concat(requiredRule)
                  )
                "
                v-model="params.smtp_server_host"
                style="width: 100%"
                :isNational="judegNational('smtp_server_host')"
                label="email.servehost*"
              ></mrc_ess_multiText>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_server_port',
                    between('1-65535').concat(integerRule).concat(requiredRule)
                  )
                "
                v-model="params.smtp_server_port"
                style="width: 100%"
                :isNational="judegNational('smtp_server_port')"
                label="email.serveport*"
              ></mrc_ess_multiText>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                v-model="params.smtp_username"
                style="width: 100%"
                :isNational="judegNational('smtp_username')"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_username',
                    maxLength(20).concat(requiredRule)
                  )
                "
                label="email.username*"
              ></mrc_ess_multiText>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_password',
                    maxLength(20).concat(requiredRule)
                  )
                "
                v-model="params.smtp_password"
                style="width: 100%"
                :isNational="judegNational('smtp_password')"
                label="email.password*"
              ></mrc_ess_multiText>
            </v-col>

            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_fromaddress',
                    maxLength(20).concat(emailRule).concat(requiredRule)
                  )
                "
                v-model="params.smtp_fromaddress"
                style="width: 100%"
                :isNational="judegNational('smtp_fromaddress')"
                label="email.fromaddress*"
              ></mrc_ess_multiText>
            </v-col>
            <v-col class="d-flex" cols="12" sm="6">
              <mrc_ess_multiText
                :readonly="disabled"
                :error-messages="
                  $errors(
                    'params',
                    'smtp_fromadname',
                    maxLength(20).concat(requiredRule)
                  )
                "
                v-model="params.smtp_fromadname"
                style="width: 100%"
                :isNational="judegNational('smtp_fromadname')"
                label="email.fromname*"
              ></mrc_ess_multiText>
            </v-col>
            <h3 v-if="disabled">{{ $t("label_test") }}</h3>
            <v-card-text v-if="disabled">
              <div class="is_flex_around">
                <v-row>
                  <v-col class="d-flex" cols="12" sm="9">
                    <v-text-field
                      label="email"
                      :placeholder="
                        $t(
                          'label_Enter_the_email_address_to_test_whether_the_email_is_received'
                        )
                      "
                    ></v-text-field>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2" offset-sm="1">
                    <v-btn
                      color="primary"
                      class="text-capitalize"
                      style="color: #fff"
                      >{{ $t("label_send") }}</v-btn
                    >
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-row>
        </v-card-text>
        <mrc_ess_submitBtn
          @cancel="cancel"
          v-if="!disabled"
          @success="success"
        ></mrc_ess_submitBtn>
      </v-card>
    </div>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  required,
  maxLength,
  between,
  email,
  url,
  integer,
} from "vuelidate/lib/validators";
import { emailSetList, emailSetUpadate } from "@/service/api/emailSetting.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      skLoading: true,
      disabled: true,
      params: {
        uuid: "",
        org_level_uuid: "", // 必填
        smtp_server_host: "", //服务器
        smtp_server_port: "", // 端口
        smtp_username: "", // 邮箱用户名
        smtp_license_code: "", // 邮箱第三方授权码
        smtp_password: "", //	发件人邮箱密码
        // smtp_encryption: "", //加密方式
        smtp_fromaddress: "", // 发件人邮箱地址
        smtp_fromadname: "", //客户端类型(web,app)
      },
    };
  },
  validations: {
    params: {
      smtp_server_host: {
        required,
        maxLength: maxLength(20),
      },
      smtp_server_port: {
        required,
        integer,
        between: between(0, 65535),
      },
      smtp_username: {
        required,
        maxLength: maxLength(20),
      },
      smtp_password: {
        required,
        maxLength: maxLength(20),
      },
      smtp_fromaddress: {
        email,
        required,
        maxLength: maxLength(20),
      },
      smtp_fromadname: {
        required,
        maxLength: maxLength(20),
      },
    },
  },
  created() {
    this.$store.commit("uuid", "");
  },
  async mounted() {
    await this.national("mrbase_sys_email_smtp");
    this.skLoading = true;
    // this.params.org_level_uuid = this.$store.state.currentCompany
    await this.getInfo();
    this.skLoading = false;
  },
  methods: {
    async getInfo() {
      const info = await emailSetList({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (info.code == 200 && Object.keys(info.data).length > 0) {
        this.params = info.data;
      }
    },
    cancel() {
      this.$myConfirm({ content: "是否放弃修改" })
        .then(async () => {
          await this.getInfo();
          this.disabled = !this.disabled;
        })
        .catch(() => {});
    },
    async success() {
      this.$v.params.$touch();
      if (this.$v.params.$error) return;
      const mail = await emailSetUpadate({
        uuid: this.params.uuid,
        org_level_uuid: this.$store.state.currentCompany, // 必填
        smtp_server_host: this.params.smtp_server_host,
        smtp_server_port: this.params.smtp_server_port,
        smtp_username: this.params.smtp_username,
        smtp_license_code: this.params.smtp_license_code,
        smtp_password: this.params.smtp_password,
        // smtp_encryption: this.params.smtp_encryption,
        smtp_fromaddress: this.params.smtp_fromaddress,
        smtp_fromadname: this.params.smtp_fromadname,
      });

      if (mail.code == 200) {
        // this.$store.commit(
        //   'newsTips',
        //   this.$t('message_The_submission_was_successful')
        // )
        this.$Message({
          text: this.$t("message_The_submission_was_successful"),
        });
        this.disabled = !this.disabled;
      }
    },
    handleReturn() {
      this.$router.go(-1);
    },
    handleEdit() {
      this.disabled = !this.disabled;
    },
    // 删除
    handleDel() {
      this.$myConfirm({ content: this.$t("message_Confirm_the_deletion") })
        .then(async () => {
          const del = await mail_del({
            org_level_uuid: this.params.org_level_uuid,
          });
          if (del.code == 200) {
            this.$Message({
              text: this.$t("message_The_deletion_was_successful"),
            });
            this.$router.go(-1);
          }
        })
        .catch(() => {});
    },
  },
  computed: {},
  watch: {},
};
</script>

<style scoped></style>
